@if (item(); as item) {
	@if (isRouteItem(item)) {
		<a
			class="block"
			[routerLink]="item.url"
			(click)="onClick()"
			[attr.data-id]="'sub-nav-entry-' + item.name"
		>
			<ng-container [ngTemplateOutlet]="headerContent"></ng-container>
		</a>
	} @else {
		<div (click)="onClick()" [attr.data-id]="'sub-nav-entry-' + item.name">
			<ng-container [ngTemplateOutlet]="headerContent"></ng-container>

			<!-- submenu -->
			@if (item.submenus) {
				<div
					class="flex flex-col h-0 opacity-0 duration-300 transition-all invisible"
					[ngClass]="{ 'h-full mb-3 opacity-100 visible!': isSubmenuOpen() }"
				>
					<!-- submenu item -->
					@for (subMenuItem of getVisibleSubmenus(item); track $index) {
						@if (isRouteItem(subMenuItem)) {
							<a
								class="flex items-center text-secondary-800 cursor-pointer text-base h-0 opacity-0 outline-0 pr-6 pl-5 relative duration-100 transition-all w-full"
								[routerLink]="subMenuItem.url"
								(click)="onClickSubMenu(subMenuItem)"
								[ngClass]="{
									'h-9.5 opacity-100': isSubmenuOpen(),
									'bg-primary-200': isSubmenuActive(subMenuItem),
									'text-secondary-400': subMenuItem.disabled,
								}"
							>
								<ng-container
									[ngTemplateOutlet]="subMenuItemContent"
									[ngTemplateOutletContext]="{ $implicit: subMenuItem }"
								></ng-container>
							</a>
						} @else {
							<div
								class="flex items-center text-secondary-800 cursor-pointer text-base h-0 opacity-0 outline-0 pr-6 pl-5 relative duration-100 transition-all w-full"
								[ngClass]="{
									'h-9.5 opacity-100': isSubmenuOpen(),
									'bg-primary-200': isSubmenuActive(subMenuItem),
									'text-secondary-400': subMenuItem.disabled,
								}"
								(click)="onClickSubMenu(subMenuItem)"
							>
								<ng-container
									[ngTemplateOutlet]="subMenuItemContent"
									[ngTemplateOutletContext]="{ $implicit: subMenuItem }"
								></ng-container>
							</div>
						}
					}
				</div>
			}
		</div>
	}
}

<ng-template #headerContent>
	<div
		class="flex items-center cursor-pointer text-base mb-2 p-2 text-secondary-800"
		[ngClass]="{ 'bg-primary-200': currentUrl().includes(item()!.url) && !item()?.callback }"
	>
		<ui-icon
			class="mr-2"
			[icon]="item()?.icon"
			size="l"
			[type]="navColor()"
			[disabled]="item()?.disabled ?? false"
		></ui-icon>
		<div
			[ngClass]="{
				'text-secondary-800': navColor() === 'dark',
				'text-primary-700': navColor() === 'primary',
				'text-white': navColor() === 'light',
				'text-secondary-400!': item()?.disabled,
			}"
		>
			<span class="flex items-center gap-2" [attr.data-id]="'nav-element-span-' + item()?.name">
				{{ item()?.name }}
				@if (item()?.beta) {
					<ui-tag text="BETA" type="dark"></ui-tag>
				}
			</span>
		</div>
	</div>
</ng-template>

<ng-template #subMenuItemContent let-subMenuItem>
	<ui-divider
		type="vertical"
		[noMargin]="true"
		[color]="navColor() === 'light' ? 'white' : 'darkGrey'"
		class="h-full inline-block"
	></ui-divider>
	<div class="flex items-center ml-4 gap-2">
		@if (subMenuItem.icon) {
			<ui-icon
				[type]="navColor()"
				[icon]="subMenuItem.icon"
				size="m"
				[disabled]="subMenuItem.disabled ?? false"
			>
			</ui-icon>
		}
		<div
			class="leading-[18px]"
			[ngClass]="{
				'text-secondary-800': navColor() === 'dark',
				'text-primary-700': navColor() === 'primary',
				'text-white': navColor() === 'light',
				'text-secondary-400!': subMenuItem.disabled,
			}"
		>
			<span class="flex items-center gap-2">
				{{ subMenuItem.name }}
				@if (subMenuItem.beta) {
					<ui-tag text="BETA" type="dark"></ui-tag>
				}
			</span>
		</div>
	</div>
</ng-template>
